<template>
    <layout-with-sidebar>
        <HeaderComponent/>
        <div class=" ed-bg text-color" style="min-height:100vh">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="navbar navbar-expand-lg navbar-light bg-light  row">
                            <div class="col-2 text-left">
                                <button class="btn btn-default "> <
                                </button>
                            </div>
                            <div class="col-6 text-center">
                                <button class="btn btn-default " @click="zoomOut">-</button>
                                <button class="btn btn-default " @click="zoomIn" style="margin-left:20px;">+</button>
                            </div>
                            <div class="col-4 text-right">

                                <button @click="save" class="btn btn-success my-2 my-sm-0" type="submit">Salva
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-10">

                        <div class=" editor-clm">
                            <div id="blocks-drag-drop2">
                                <!-- gjs blockManager  -->
                            </div>


                            <div id="gjs-canvas">

                            </div>
                        </div>


                    </div>

                    <div class="col-2">
                        <div id="panel01">
                            <!-- Style Manager here -->
                            Trascina elementi nel foglio


                            <div id="blocks-drag-drop"></div>
                            <br>
                            <div id="style-manager-container"></div>




                        </div>
                    </div>
                </div>


            </div>
        </div>
    </layout-with-sidebar>
</template>


<script>
    // @ is an alias to /src

    import grapesjs from 'grapesjs'
    import 'grapesjs-preset-webpage'
    import axios from 'axios'
    import download from 'downloadjs'

    // import LayoutWithSidebar from "./layouts/LayoutWithSidebar";
    import HeaderComponent from "../../components/HeaderComponent";

    export default {
        name: 'HtmlEditor',
        components: {
            //     LayoutWithSidebar,
            HeaderComponent,
        },
        data: function () {
            return {
                zoom: 100,
                paperSizes: {
                    a4: {
                        landscape: {
                            width: 297,
                            height: 210
                        },
                        portrait: {
                            height: 297,
                            width: 210
                        }
                    },
                    a1: {
                        width: 841,
                        height: 594
                    }
                },
                editor: null,
                fields: [
                    /*{
                        id: 'amortization.debtor_first_name',
                        placeholder: 'amortization.debtor_first_name',
                        position: {
                            top: '220px',
                            left: '484px'
                        }
                    },*/
                    {
                        id: 'amortization.debtor_last_name',
                        placeholder: 'congome debitore',
                        position: {
                            top: 220,
                            left: 338
                        }
                    },
                    {
                        id: 'amortization.debtor_fiscal_code',
                        placeholder: 'codice fiscale debitore',
                        position: {
                            top: 248,
                            left: 338
                        }
                    },
                    {
                        id: 'amortization.debtor_address',
                        placeholder: 'amortization.debtor_address',
                        position: {
                            top: 277.55,
                            left: 338
                        }
                    }
                ]
            }
        }
        ,
        mounted: function () {

            var vm = this

            this.editor = grapesjs.init({
                container: '#gjs-canvas',
                fromElement: 1,
                // fromElement: true,
                width: vm.paperSizes.a4.landscape.width + 'mm',
                height: vm.paperSizes.a4.landscape.height + 'mm',
                // width: '100%',
                components: [],
                storageManager: {type: 0},
                // dragMode: 'absolute',

                // avoidInlineStyle: 1,
                plugins: ['gjs-blocks-basic'],
                blockManager: {
                    appendTo: '#blocks-drag-drop'
                },
                pluginsOpts: {
                    "gjs-blocks-basic": {
                        blocks: ['text', 'image']
                    }
                },
                panels: {
                    defaults: [
                        {
                            id: 'container-style-manager',
                            el: '#panel01'
                        },
                        // Is the small toolbar (blue light) that you see when select a component on canvas
                        {
                            id: 'select',
                            className: 'fa fa-mouse-pointer',
                            command: 'select-comp',
                        }
                    ]
                },


                styleManager: {
                    appendTo: '#style-manager-container',
                    sectors: [
                        {
                            id: 'typography',
                            name: 'Tipografia',
                            open: false,
                            buildProps: ['font-family', 'font-size', 'font-weight', 'letter-spacing', 'color', 'line-height', 'text-align', 'text-shadow']
                        }, {
                            id: 'decorations',
                            name: 'Decorazioni',
                            open: false,
                            buildProps: ['background-color', 'background-image', 'background-repeat'],
                            // buildProps: ['border-radius-c', 'background-color', 'border-radius', 'border', 'box-shadow', 'background'],
                        }, {
                            id: 'extra',
                            name: 'Extra',
                            open: false,
                            buildProps: ['opacity'],
                            properties: [{
                                type: 'slider',
                                property: 'opacity',
                                defaults: 1,
                                step: 0.01,
                                max: 1,
                                min: 0,
                            }]
                        }],


                },

                commands: {
                    defaults: [
                        {
                            id: "undo",
                            run: function (editor, sender) {
                                sender.set("active", false);
                                editor.UndoManager.undo(1);
                            }
                        },
                        {
                            id: "redo",
                            run: function (editor, sender) {
                                sender.set("active", false);
                                editor.UndoManager.redo(1);
                            }
                        }
                    ]
                },
            });

            this.editor.on('styleManager:update:target', (component) => {
                console.log(component)
              /*  let selectedComponent = vm.editor.getSelected()
                if (component === selectedComponent) {
                    let attributes = selectedComponent.getAttributes()
                    if (typeof attributes.field === 'undefined') {
                        const styleManager = vm.editor.StyleManager;
                        styleManager.getSector('typography').set({open: true})
                        var style = selectedComponent.getStyle();
                        style['font-size'] = '24px';
                        selectedComponent.setStyle(style);
                    }
                }*/
            })

            this.editor.on('component:update', (component) => {
                let selectedComponent = vm.editor.getSelected()
                if (component === selectedComponent) {
                    let attributes = selectedComponent.getAttributes()
                    if (typeof attributes.field === 'undefined') {
                    /*    const styleManager = vm.editor.StyleManager;
                        styleManager.getSector('typography').set({open: true})
                        var style = selectedComponent.getStyle();
                        style['font-size'] = '24px';
                        selectedComponent.setStyle(style);*/
                    }
                }
            })
            // Set absolute by Style Manager
            this.editor.getModel().set('dmode', 'absolute');
            this.editor.runCommand('sw-visibility');

            const styleManager = this.editor.StyleManager;
            styleManager.addSector('Dimension', {
                id: 'dimension',
                name: 'Dimension',
                open: false,
                properties: [{
                    name: 'Margine dall\'alto',
                    property: 'top',
                    defaults: '0',
                    units: ['px'],
                    unit: 'px',
                    type: 'integer'
                },
                    {
                        name: 'Margine da sinistra',
                        property: 'left',
                        defaults: '0',
                        units: ['px'],
                        unit: 'px',
                        type: 'integer'
                    }],

            }, {at: 0});

            const domComponents = this.editor.DomComponents;


            const wrapper = domComponents.getWrapper();
            wrapper.set({
                style: {
                    "background-image": "url(/images/cambiale_esempio.png)",
                    "background-repeat": 'no-repeat',
                    "background-size": "247.5mm auto"
                }
            });

            const bm = this.editor.BlockManager;
            bm.render([
                bm.get('text').set('category', ''),
                bm.get('image').set('category', '')
            ])


            // Try to make something to a component selcted on canvas
            this.editor.on("component:selected", function (args) {
                args.attributes.resizable = true;
            });
            // Add a component on canvas in a particular place
            var index = 1
            var vm = this
            vm.fields.forEach(function (field) {
                var component = vm.editor.addComponents('<div>' + field.placeholder + '</div>', {at: index})[0];
                component.setStyle({
                    width: 'auto',
                    top: field.position.top + 'px',
                    left: field.position.left + 'px',
                    position: 'absolute'
                })
                component.set({
                    attributes: {
                        field: field.id
                    },
                    removable: false
                });
                index++
            })


        }
        ,
        computed: {}
        ,
        methods: {
            zoomOut: function () {
                this.zoom -= 10
                const canvas = this.editor.Canvas;
                canvas.setZoom(this.zoom)
            }
            ,
            zoomIn: function () {
                this.zoom += 10
                const canvas = this.editor.Canvas;
                canvas.setZoom(this.zoom)
            }
            ,
            save: function () {
                const domComponents = this.editor.DomComponents;
                const wrapper = domComponents.getWrapper();
                axios({
                    url: 'http://ws.cambialefacile.it/api/v1/pdf/preview',
                    method: 'POST',
                    responseType: 'blob', // important
                    data: {
                        html: this.editor.getHtml(),
                        css: this.editor.getCss(),
                        image: wrapper.getStyle()
                    }
                }).then((response) => {
                    //Create a Blob from the PDF Stream
                    const file = new Blob(
                        [response.data],
                        {type: 'application/pdf'})//Build a URL from the file
                    URL.createObjectURL(file)//Open the URL on new Window

                    const content = response.headers['content-type'];
                    var today = new Date();
                    var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
                    download(response.data, date + ' Pratica Cambiale #123.pdf', content)


                })


            }
        }
    }
</script>


<style>

    @import '../../../node_modules/grapesjs/dist/css/grapes.min.css';
    @import '../../../node_modules/grapesjs-preset-webpage/dist/grapesjs-preset-webpage.min.css';

    /* .col-1{
        border: solid 1px red;
    }
    .col-2{
        border: solid 1px blue;
    }
    @media screen and (min-width: 960px) {
      .layout-content_66-33{
        margin-left: 10px !important;
      }
    } */


    .box {
        display: flex;
    }

    .push {
        margin-left: auto;
    }


    body, html {
        margin: 0;
        font: caption;
        height: 100%;
    }

    .gjs-pn-panel {
        position: relative;
    }

    .row {
        display: flex;
        justify-content: flex-start;
        align-items: stretch;
        flex-wrap: nowrap;
    }

    .column {
        min-height: 75px;
        flex-grow: 1;
        flex-basis: 100%;
        overflow: auto;
    }

    .editor-clm {
        display: flex;
        flex-direction: column;
    }

    .gjs-blocks-c {
        justify-content: center;
        height: 50px;
    }

    .gjs-block {
        width: auto;
        font-size: 5px;
        justify-content: center;
        height: auto;
        min-height: auto;
    }

    .gjs-block-label {
        display: none;
    }

    .gjs-cv-canvas {
        width: 100%;
        height: 100%;
        top: 0;
    }

    .gjs-blocks-cs {
        border: 1px solid rgba(0, 0, 0, 0.3);
        border-top: none;
    }

    /* Theming */
    .gjs-one-bg {
        background-color: #242A3B;
    }

    .gjs-two-color {
        color: #9ca8bb;
    }

    .gjs-three-bg {
        background-color: #1E8FE1;
        color: white;
    }

    .gjs-four-color,
    .gjs-four-color-h:hover {
        color: #1E8FE1;
    }

    .gjs-cv-canvas {
        background: #ececec
    }

    /*
        .gjs-cv-canvas{
            overflow: auto !important;
        }*/
    .btn.btn-default {
        border: 1px solid #212529;
    }
</style>
